import React from "react";
import "./App.css";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Route, Switch } from "react-router-dom";
import Home from "./components/Home";
import About from "./components/About";
import CoreAreas from "./components/CoreAreas";
import Projects from "./components/Projects";
import NIP from "./components/NIP";
import AIP from "./components/AIP";
import Contact from "./components/Contact";
import Team from "./components/Team";
import Gallery from "./components/Gallery";
import Programs from "./components/Programs";

const theme = createTheme({
  typography: {
    fontFamily: {
      fontFamily: "Noto Sans",
    },
  },
});

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <div className="App">
          <Switch>
            <Route exact path="/our-programs" component={Programs} />
            <Route exact path="/our-gallery" component={Gallery} />
            <Route exact path="/contact-us" component={Contact} />
            <Route
              exact
              path="/our-aquaculture-intervention-program"
              component={AIP}
            />
            <Route
              exact
              path="/our-neighbourhood-impact-program"
              component={NIP}
            />
            <Route exact path="/our-team" component={Team} />
            <Route exact path="/our-impact" component={Projects} />
            <Route exact path="/our-core-areas" component={CoreAreas} />
            <Route exact path="/about-us" component={About} />
            <Route exact path="/" component={Home} />
          </Switch>
        </div>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
